import TopicStatus from '../../../api/TopicStatus';
import * as types from './mutation-types';

export const index = async ({commit}) => {
    const json = await new TopicStatus().index();

    commit(types.TOPIC_STATUSES, json);
};

export default {
    index,
};



// WEBPACK FOOTER //
// ./src/store/modules/topicStatus/actions.js